import { Divider, Popconfirm, Tooltip } from 'antd';
import {
  ContainerOutlined,
  RollbackOutlined,
  WarningOutlined
} from '@ant-design/icons';

/**
 * Creates archive/unarchive action buttons with Popconfirm.
 * This eliminates code duplication between different column files.
 * @function
 * @param {Object} params - Configuration parameters
 * @param {Function} params.t - Translation function
 * @param {Function} params.deleteResource - Function to archive a resource
 * @param {Function} params.restoreResource - Function to unarchive a resource
 * @param {Object} params.record - The record object containing is_archived and _id
 * @returns {JSX.Element} Archive/unarchive action buttons
 */
export const createArchiveUnarchiveActions = ({
  t,
  deleteResource,
  restoreResource,
  record
}) => (
  <>
    <Divider type="vertical" />
    {!record.is_archived ? (
      <Popconfirm
        title={t('datatable.column.action.archive.title')}
        okText={t('datatable.column.action.archive.ok')}
        okButtonProps={{ type: 'danger' }}
        cancelText={t('datatable.column.action.archive.cancel')}
        onConfirm={() => deleteResource(record?._id)}
        icon={<WarningOutlined />}
      >
        <Tooltip
          title={t('datatable.column.action.archive.hover')}
          placement="left"
        >
          <ContainerOutlined
            style={{ color: '#b51010', fontSize: 18 }}
            type="delete"
          />
        </Tooltip>
      </Popconfirm>
    ) : (
      <Popconfirm
        title={t('datatable.column.action.unarchived.title')}
        okText={t('datatable.column.action.unarchived.ok')}
        okButtonProps={{ type: 'danger' }}
        cancelText={t('datatable.column.action.unarchived.cancel')}
        onConfirm={() => restoreResource(record?._id)}
        icon={<WarningOutlined />}
      >
        <Tooltip
          title={t('datatable.column.action.unarchived.hover')}
          placement="left"
        >
          <RollbackOutlined style={{ color: '#b51010', fontSize: 18 }} />
        </Tooltip>
      </Popconfirm>
    )}
  </>
);
